import { memo } from 'react';
import classNames from 'classnames';
import styled from 'styled-components';

import { Avatar, AvatarSize } from '@xemplo/avatar';
import { Colour, TextEllipsis } from '@xemplo/style-constants';

import * as S from './cell.style';
import { NameCellProps } from './cell.types';

const StyledNameWrapper = styled.span`
  display: inline-block;
  ${TextEllipsis};
  color: ${Colour.Gray[600]};
`;

export const NameCellTestId = {
  name: 'name-cell-wrapper',
};

/** This has been used in a lot of places so I won't change it. */
export const NameCell = memo((props: NameCellProps) => {
  const { avatarColor } = props;
  return (
    <S.CellContent className={props.className}>
      <Avatar user={remapUserName(props)} size={AvatarSize.s} color={avatarColor} />
      <StyledNameWrapper data-testid={NameCellTestId.name}>
        {props.firstName} {props.lastName}
      </StyledNameWrapper>
    </S.CellContent>
  );
});

/** Variant of the `NameCell` that includes the email address */
export const NameCellWithEmail = memo((props: NameCellProps) => {
  const { avatarColor, className, email } = props;

  return (
    <S.CellContent className={classNames(className)}>
      <Avatar user={remapUserName(props)} size={AvatarSize.s} color={avatarColor} />
      <S.TextWrapper>
        <S.Name>
          {props.firstName} {props.lastName}
        </S.Name>
        {email && <S.Email>{email}</S.Email>}
      </S.TextWrapper>
    </S.CellContent>
  );
});

/**
 * FD-1504:
 * This function is used to ensure that the user object has the correct properties
 * for the NameCell component, especially when the firstName or lastName might be missing.
 * Some endpoints only return a full name, so we split it to get the last name.
 */
function remapUserName(user: NameCellProps) {
  return {
    ...user,
    firstName: user.firstName || '',
    lastName: user.lastName || '',
  };
}
